// extracted by mini-css-extract-plugin
export default {"container":"Canvas_container__Dc93s","canvas":"Canvas_canvas__DpWst"};